import MobileSearchBar from 'shared/mobile-search-bar'
import SubNav from 'hello_baby/components/sub-nav'
import { helloBabySearchPath } from 'lib/urls'
import { useLocation, useParams } from 'react-router-dom-v5-compat'
import { useMinimalView, useTopicNavigation } from '../../utils/useQueries'

const GuidesNav: React.FC = () => {
  const location = useLocation()
  const minimalView = useMinimalView()
  const topicNavigation = useTopicNavigation()

  const searchTerm = new URLSearchParams(location.search).get('search_term')
  const { slug } = useParams()

  return (
    <div>
      {!minimalView && topicNavigation && (
        <>
          <SubNav
            className="hidden-xs"
            searchTerm={searchTerm}
            topicSlug={slug}
            topics={topicNavigation.items}
          />
          <MobileSearchBar
            placeholder="Search guides"
            submitPath={helloBabySearchPath}
          />
        </>
      )}
    </div>
  )
}

export default GuidesNav
